import React from "react";
import styled from 'styled-components';

const StyledTabGroup = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
	border-bottom: 1px solid ${(props) => props.theme.colors.neutral6};
	margin-bottom: 1.5rem;
`;

export function TabGroup({ children, ...props }) {
	return <StyledTabGroup role="tablist" {...props}>{children}</StyledTabGroup>;
}